import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

interface SeoOptions {
  title: string
  description?: string
}

/**
 * Per-route SEO: sets document.title, the meta description and keeps
 * <html lang> in sync with the active i18n language.
 * The static defaults live in index.html (served to crawlers without JS);
 * this hook refines them once React takes over.
 */
export function useSeo({ title, description }: SeoOptions): void {
  const { i18n } = useTranslation()

  useEffect(() => {
    document.title = title
    if (description) {
      let meta = document.querySelector('meta[name="description"]')
      if (!meta) {
        meta = document.createElement('meta')
        meta.setAttribute('name', 'description')
        document.head.appendChild(meta)
      }
      meta.setAttribute('content', description)
    }
  }, [title, description])

  useEffect(() => {
    document.documentElement.lang = i18n.language?.startsWith('en') ? 'en' : 'fr'
  }, [i18n.language])
}
